import { ObservableInputsManager } from '@/shared/utils/angular-sdk';
import { interpolateString } from '@/utils/toolkit/string/interpolate-string.utils';
import { isNotNullish } from '@/utils/typing/is-nullish.predicate';
import { AsyncPipe, NgClass, NgStyle } from '@angular/common';
import { ChangeDetectionStrategy, Component, type SimpleChanges, inject } from '@angular/core';
import { DomSanitizer, type SafeHtml } from '@angular/platform-browser';
import DOMPurify from 'dompurify';
import { type ObservableInput, combineLatest } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RosaAuthService } from '../../../libs/rosa';
import { AbstractTailoredTemplateWidget } from '../AbstractTailoredWidgetTemplate.class';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./template-widget-html-content.scss'],
    selector: 'template-widget-html-content',
    templateUrl: 'template-widget-html-content.html',
    imports: [NgStyle, NgClass, AsyncPipe]
})
export class TemplateWidgetHtmlContentComponent extends AbstractTailoredTemplateWidget<{
    value: string;
    verticalAlignment?: string;
    backgroundColor?: string;
}> {
    private _sanitizer = inject(DomSanitizer);
    private _rosaAuthService = inject(RosaAuthService);

    private _observableInputsManager = new ObservableInputsManager<TemplateWidgetHtmlContentComponent>(this);
    sanitizedHtml$!: ObservableInput<SafeHtml>;
    config$ = this._observableInputsManager.observe('config');
    ngOnInit() {
        this.sanitizedHtml$ = combineLatest([this.config$, this._rosaAuthService.getToken$().pipe(filter(isNotNullish))]).pipe(
            map(([config, token]) => {
                /*
                    This code is to allow geoss to connect. It is not a good practice to send private tokens

                    All responsibilities in case of a security breach due to that code are taken by Pierre-Eric OUDIN

                */
                return this._sanitizer.bypassSecurityTrustHtml(
                    DOMPurify.sanitize(interpolateString(config.value, { refresh_token: token.access_token }), {
                        USE_PROFILES: { html: true },
                        ADD_ATTR: ['target']
                    })
                );
            })
        );
    }
    ngOnChanges(changes: SimpleChanges): void {
        this._observableInputsManager.triggerChanges(changes);
    }
}
